import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import ComingSoon from '../../../commonComponent/ComingSoon';

function Pms() {
  const navigate = useNavigate(); // Initialize useNavigate for routing

  return (
    <div>
      <div className=" p-6 bg-gray-100">
        <header className="flex justify-between items-center mb-3 bg-white p-3">
          <h1 className="text-black text-xl font-bold ml-2">P M S</h1>
          <div className="flex space-x-6">
            {/* <button
              onClick={() =>
                navigate("/dashboard/core-modules/property-management-system")
              }
              className="btn text-black font-bold"
            >
             Reservation & Guest Booking
            </button> */}
            <button
              onClick={() =>
                navigate('/dashboard/core-modules/property-management-system/front-desk-operations')
              }
              className="btn "
            >
              Front Desk Operations
            </button>
            <button
              onClick={() =>
                navigate('/dashboard/core-modules/property-management-system/guest-managment')
              }
              className="btn "
            >
              Guest Management
            </button>
            <button
              onClick={() =>
                navigate(
                  '/dashboard/core-modules/property-management-system/front-desk-roomservices'
                )
              }
              className="btn"
            >
              Hospitality Services
            </button>
            <button
              onClick={() =>
                navigate('/dashboard/core-modules/property-management-system/front-desk-amenities')
              }
              className="btn "
            >
              Facility Services
            </button>
            <button
              onClick={() =>
                navigate('/dashboard/core-modules/property-management-system/billing-payments')
              }
              className="btn "
            >
              Billing & Payments
            </button>
          </div>
        </header>

        <ComingSoon />
      </div>
    </div>
  );
}

export default Pms;
